import { forIn } from 'lodash'
import Vue from 'vue'

const CUSTOM_COMPONENT_CONFIG = {
}
export default () => {
  forIn(CUSTOM_COMPONENT_CONFIG, (val, key) => {
    Vue.component(key, val)
  })
}
